import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.flashCardsStepOneExtraLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.flashCardsStepOneExtraLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) =>
    state.flashCardsStepOneExtraLevels.data.flashCardsStepOneExtraLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
